export default __webpack_public_path__ + "static/media/i230jk.cfb2dcd6.webp";